import { WorldCountry } from '../types';

export const northAmericaCountries: WorldCountry[] = [
  {
    code: 'CA',
    name: 'Canada',
    slug: 'canada',
    population: 37742154,
    topCities: [
      { name: 'Toronto', slug: 'toronto', population: 2731000 },
      { name: 'Montreal', slug: 'montreal', population: 1704000 },
      { name: 'Calgary', slug: 'calgary', population: 1239000 },
      { name: 'Ottawa', slug: 'ottawa', population: 934000 },
      { name: 'Edmonton', slug: 'edmonton', population: 932000 },
      { name: 'Mississauga', slug: 'mississauga', population: 721000 },
      { name: 'Winnipeg', slug: 'winnipeg', population: 705000 },
      { name: 'Vancouver', slug: 'vancouver', population: 631000 },
      { name: 'Brampton', slug: 'brampton', population: 594000 },
      { name: 'Hamilton', slug: 'hamilton', population: 536000 },
      { name: 'Quebec City', slug: 'quebec-city', population: 531902 },
      { name: 'Surrey', slug: 'surrey', population: 517887 },
      { name: 'Laval', slug: 'laval', population: 422993 },
      { name: 'Halifax', slug: 'halifax', population: 403131 },
      { name: 'London', slug: 'london-ca', population: 383822 },
      { name: 'Markham', slug: 'markham', population: 328966 },
      { name: 'Vaughan', slug: 'vaughan', population: 306233 },
      { name: 'Gatineau', slug: 'gatineau', population: 276245 },
      { name: 'Saskatoon', slug: 'saskatoon', population: 246376 },
      { name: 'Longueuil', slug: 'longueuil', population: 239700 },
      { name: 'Burnaby', slug: 'burnaby', population: 232755 },
      { name: 'Regina', slug: 'regina', population: 215106 },
      { name: 'Richmond', slug: 'richmond-ca', population: 198309 },
      { name: 'Richmond Hill', slug: 'richmond-hill', population: 195022 },
      { name: 'Oakville', slug: 'oakville', population: 193832 },
      { name: 'Burlington', slug: 'burlington', population: 183314 },
      { name: 'Greater Sudbury', slug: 'greater-sudbury', population: 161531 },
      { name: 'Sherbrooke', slug: 'sherbrooke', population: 161323 },
      { name: 'Oshawa', slug: 'oshawa', population: 159458 },
      { name: 'Saguenay', slug: 'saguenay', population: 145949 },
      { name: 'Lévis', slug: 'levis', population: 143414 },
      { name: 'Barrie', slug: 'barrie', population: 141434 },
      { name: 'Abbotsford', slug: 'abbotsford', population: 141397 },
      { name: 'St. Catharines', slug: 'st-catharines', population: 133113 },
      { name: 'Trois-Rivières', slug: 'trois-rivieres', population: 134413 },
      { name: 'Guelph', slug: 'guelph', population: 131794 },
      { name: 'Cambridge', slug: 'cambridge-ca', population: 129920 },
      { name: 'Whitby', slug: 'whitby', population: 128377 },
      { name: 'Kelowna', slug: 'kelowna', population: 127380 },
      { name: 'Kingston', slug: 'kingston-ca', population: 123798 },
      { name: 'Ajax', slug: 'ajax', population: 119677 },
      { name: 'Langley', slug: 'langley', population: 117285 },
      { name: 'Saanich', slug: 'saanich', population: 114148 },
      { name: 'Milton', slug: 'milton', population: 110128 },
      { name: 'Coquitlam', slug: 'coquitlam', population: 139284 },
      { name: 'Thunder Bay', slug: 'thunder-bay', population: 107909 },
      { name: 'Waterloo', slug: 'waterloo', population: 104986 },
      { name: 'Delta', slug: 'delta-ca', population: 102238 },
      { name: 'Chatham-Kent', slug: 'chatham-kent', population: 101647 },
      { name: 'Red Deer', slug: 'red-deer', population: 100418 },
      { name: 'Kamloops', slug: 'kamloops', population: 90280 },
      { name: 'Brantford', slug: 'brantford', population: 97496 },
      { name: 'Cape Breton', slug: 'cape-breton', population: 94285 },
      { name: 'Lethbridge', slug: 'lethbridge', population: 92729 },
      { name: 'Saint-Jean-sur-Richelieu', slug: 'saint-jean-sur-richelieu', population: 92394 },
      { name: 'Clarington', slug: 'clarington', population: 92013 },
      { name: 'Pickering', slug: 'pickering', population: 91771 },
      { name: 'Nanaimo', slug: 'nanaimo', population: 90504 },
      { name: 'Sudbury', slug: 'sudbury', population: 88054 },
      { name: 'North Vancouver', slug: 'north-vancouver', population: 85935 },
      { name: 'Brossard', slug: 'brossard', population: 85721 },
      { name: 'Repentigny', slug: 'repentigny', population: 84965 },
      { name: 'Newmarket', slug: 'newmarket', population: 84224 },
      { name: 'Chilliwack', slug: 'chilliwack', population: 83788 },
      { name: 'White Rock', slug: 'white-rock', population: 82368 },
      { name: 'Maple Ridge', slug: 'maple-ridge', population: 82256 },
      { name: 'Peterborough', slug: 'peterborough', population: 81032 },
      { name: 'Kawartha Lakes', slug: 'kawartha-lakes', population: 75423 },
      { name: 'Prince George', slug: 'prince-george', population: 74003 },
      { name: 'Moncton', slug: 'moncton', population: 71889 },
      { name: 'Granby', slug: 'granby', population: 66222 },
      { name: 'St. Albert', slug: 'st-albert', population: 65589 },
      { name: 'Medicine Hat', slug: 'medicine-hat', population: 63260 },
      { name: 'Drummondville', slug: 'drummondville', population: 68334 },
      { name: 'Saint-Hyacinthe', slug: 'saint-hyacinthe', population: 55823 },
      { name: 'Shawinigan', slug: 'shawinigan', population: 49349 },
      { name: 'Dollard-des-Ormeaux', slug: 'dollard-des-ormeaux', population: 48930 },
      { name: 'Châteauguay', slug: 'chateauguay', population: 46012 },
      { name: 'Blainville', slug: 'blainville', population: 56863 },
      { name: 'Saint-Eustache', slug: 'saint-eustache', population: 44154 },
      { name: 'Rimouski', slug: 'rimouski', population: 48664 },
      { name: 'Sarnia', slug: 'sarnia', population: 71594 },
      { name: 'Wood Buffalo', slug: 'wood-buffalo', population: 71589 },
      { name: 'Mascouche', slug: 'mascouche', population: 42491 },
      { name: 'Terrebonne', slug: 'terrebonne', population: 111575 },
      { name: 'Rouyn-Noranda', slug: 'rouyn-noranda', population: 42334 },
      { name: 'Victoriaville', slug: 'victoriaville', population: 46322 },
      { name: 'Joliette', slug: 'joliette', population: 20246 },
      { name: 'Belleville', slug: 'belleville', population: 50716 },
      { name: 'Fredericton', slug: 'fredericton', population: 58220 },
      { name: 'Saint John', slug: 'saint-john', population: 67575 },
      { name: 'Charlottetown', slug: 'charlottetown', population: 36094 },
      { name: 'Grande Prairie', slug: 'grande-prairie', population: 63166 },
      { name: 'Airdrie', slug: 'airdrie', population: 61581 },
      { name: 'Halton Hills', slug: 'halton-hills', population: 61161 },
      { name: 'Saint-Laurent', slug: 'saint-laurent', population: 93842 },
      { name: 'Sydney', slug: 'sydney-ca', population: 31597 },
      { name: 'Okotoks', slug: 'okotoks', population: 28881 },
      { name: 'Innisfil', slug: 'innisfil', population: 36566 },
      { name: 'Georgina', slug: 'georgina', population: 45418 },
      { name: 'Aurora', slug: 'aurora-ca', population: 55445 },
      { name: 'Welland', slug: 'welland', population: 52293 },
      { name: 'North Bay', slug: 'north-bay', population: 51553 },
      { name: 'Beaconsfield', slug: 'beaconsfield', population: 19194 },
      { name: 'Côte-Saint-Luc', slug: 'cote-saint-luc', population: 32448 },
      { name: 'Pointe-Claire', slug: 'pointe-claire', population: 31380 },
      { name: 'Kirkland', slug: 'kirkland', population: 20151 }
    ]
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    slug: 'puerto-rico',
    population: 2860853,
    topCities: [
      { name: 'San Juan', slug: 'san-juan-pr', population: 318000 },
      { name: 'Bayamón', slug: 'bayamon', population: 185000 },
      { name: 'Carolina', slug: 'carolina-pr', population: 154000 },
      { name: 'Ponce', slug: 'ponce', population: 132000 },
      { name: 'Caguas', slug: 'caguas', population: 127000 },
      { name: 'Guaynabo', slug: 'guaynabo', population: 97000 },
      { name: 'Arecibo', slug: 'arecibo', population: 87000 },
      { name: 'Toa Baja', slug: 'toa-baja', population: 89000 },
      { name: 'Mayagüez', slug: 'mayaguez', population: 73000 },
      { name: 'Trujillo Alto', slug: 'trujillo-alto', population: 70000 }
    ]
  }
];
